<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="members"
      class="p-no-borders"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:[`item.contact`]="{ item }">
        <p-contact-item
          :contact="item.contact"
          class="px-0"
          font-bold
          :isAnonymousMember="!item.contact.displayName"
        ></p-contact-item>
      </template>
      <template v-slot:[`item.travelCost`]="{ item }">
        <p-currency :value="item.travelCost"></p-currency>
      </template>
      <template v-slot:[`item.dietPerDay`]="{ item }">
        <p-currency :value="item.dietPerDay"></p-currency>
      </template>
      <template v-slot:[`item.totalDiet`]="{ item }">
        <p-currency :value="item.totalDiet"></p-currency>
      </template>
      <template v-slot:[`item.hotelPerDay`]="{ item }">
        <p-currency :value="item.hotelPerDay"></p-currency>
      </template>
      <template v-slot:[`item.totalHotels`]="{ item }">
        <p-currency :value="item.totalHotels"></p-currency>
      </template>
      <template v-slot:[`item.otherCost`]="{ item }">
        <p-currency :value="item.otherCost"></p-currency>
      </template>
      <template v-slot:[`item.wage`]="{ item }">
        <p-currency :value="item.wage"></p-currency>
      </template>
      <template v-slot:[`item.totalCost`]="{ item }">
        <p-currency :value="item.totalCost"></p-currency>
      </template>
      <template v-if="hasAccess()" v-slot:[`item.actions`]="{ item }">
        <div class="p-table-row-actions p-visible-on-row-hover">
          <p-btn-icon type="edit" @click="openEditDialog(item)"></p-btn-icon>
          <p-btn-icon type="delete" @click="deleteMember_(item)"></p-btn-icon>
        </div>
      </template>
      <template v-slot:[`body.append`]>
        <tr>
          <td colspan="100%" style="padding: 0; height: auto;">
            <v-divider></v-divider>
          </td>
        </tr>
        <tr class="p-members-table-total-row">
          <td colspan="10"></td>
          <td class="font-weight-medium text-right text--secondary">{{ $t('budget.table.total') }}</td>
          <td class="font-weight-medium text-right">
            <p-currency
              :value="totalCost"
              display-currency
            ></p-currency></td>
        </tr>
      </template>
    </v-data-table>

    <member-edit-dialog
      :dialog.sync="editDialog"
      :member="editMember"
    ></member-edit-dialog>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

import MemberEditDialog from '@/views/Members/MemberEditDialog'
import PContactItem from '@/components/PContactItem'
import PBtnIcon from '@/components/PBtnIcon'
import PCurrency from '@/components/PCurrency'

import snackbarMixin from '@/mixins/snackbar.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    MemberEditDialog,
    PContactItem,
    PBtnIcon,
    PCurrency
  },


  mixins: [
    snackbarMixin,
    accessMixin
  ],


  data () {
    return {
      editDialog: false,
      editMember: null
    }
  },


  computed: {
    ...mapGetters('member', ['membersByProject']),
    ...mapGetters('contact', ['shortContactById']),
    ...mapGetters('project', ['currentProjectId']),

    tableHeaders () {
      return [
        { text: this.$t('member.table.contact'), value: 'contact' },
        { text: this.$t('member.table.function'), value: 'function' },
        { text: this.$t('member.table.travelCost'), value: 'travelCost', align: 'end' },
        { text: this.$t('member.table.dietDays'), value: 'dietDays', align: 'end' },
        { text: this.$t('member.table.dietPerDay'), value: 'dietPerDay', align: 'end' },
        { text: this.$t('member.table.totalDiet'), value: 'totalDiet', align: 'end' },
        { text: this.$t('member.table.hotelDays'), value: 'hotelDays', align: 'end' },
        { text: this.$t('member.table.hotelPerDay'), value: 'hotelPerDay', align: 'end' },
        { text: this.$t('member.table.totalHotels'), value: 'totalHotels', align: 'end' },
        { text: this.$t('member.table.otherCost'), value: 'otherCost', align: 'end' },
        { text: this.$t('member.table.wage'), value: 'wage', align: 'end' },
        { text: this.$t('member.table.totalCost'), value: 'totalCost', align: 'end' },
        { text: '', value: 'actions', align: 'end', width: 75, sortable: false, filterable: false }
      ]
    },

    members () {
      return this.membersByProject(this.currentProjectId)
    },

    totalCost () {
      return this.members.reduce((sum, member) => {
        return sum + member.totalCost
      }, 0)
    }
  },


  watch: {
    totalCost () {
      this.$emit('change')
    }
  },


  methods: {
    ...mapActions('member', ['deleteMember']),

    openEditDialog (member) {
      this.editMember = member
      this.editDialog = true
    },

    async deleteMember_ (member) {
      try {
        const confirm = await this.$confirm(this.$t('member.deleteMemberConfirm', { name: member.contact.displayNameWithCompany }), { trueText: this.$t('delete') })
        if (confirm === true) {
          this.showSnackbarProcessing()
          await this.deleteMember(member)
          this.showSnackbarSuccess(this.$t('member.memberDeleted'))
        }
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
